import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiMail, FiPhone, FiMapPin, FiLinkedin } = FiIcons;

const Footer = () => {
  const openPrivacyPolicy = () => {
    window.open('#/datenschutz', 'datenschutz', 'width=800,height=600,scrollbars=yes');
  };

  const openImpressum = () => {
    window.open('#/impressum', 'impressum', 'width=800,height=600,scrollbars=yes');
  };

  return (
    <footer className="bg-[#1A1A1A] text-white py-16">
      <div className="container mx-auto px-6 lg:px-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          <motion.div 
            initial={{ opacity: 0, y: 30 }} 
            whileInView={{ opacity: 1, y: 0 }} 
            transition={{ duration: 0.6 }} 
            viewport={{ once: true }}
          >
            <h3 className="text-2xl font-bold mb-6">
              Smarte Buchhaltung. <span className="text-[#E30613]">Online.</span>
            </h3>
            <p className="text-gray-300 leading-relaxed mb-6">
              Digitale Buchhaltung für Selbstständige – verständlich, strukturiert und ohne Stress.
            </p>
            <div className="flex space-x-4">
              <a 
                href="https://www.linkedin.com/in/nadine-rau-1267752bb/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-gray-400 hover:text-red-500 transition-colors"
              >
                <SafeIcon icon={FiLinkedin} className="text-xl" />
              </a>
            </div>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, y: 30 }} 
            whileInView={{ opacity: 1, y: 0 }} 
            transition={{ duration: 0.6, delay: 0.1 }} 
            viewport={{ once: true }}
          >
            <h4 className="text-lg font-semibold mb-6">Rechtliches</h4>
            <ul className="space-y-3">
              <li>
                <button 
                  onClick={openImpressum}
                  className="text-gray-300 hover:text-red-500 transition-colors"
                >
                  Impressum
                </button>
              </li>
              <li>
                <button 
                  onClick={openPrivacyPolicy}
                  className="text-gray-300 hover:text-red-500 transition-colors"
                >
                  Datenschutz
                </button>
              </li>
            </ul>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, y: 30 }} 
            whileInView={{ opacity: 1, y: 0 }} 
            transition={{ duration: 0.6, delay: 0.2 }} 
            viewport={{ once: true }}
          >
            <h4 className="text-lg font-semibold mb-6">Kontakt</h4>
            <ul className="space-y-4">
              <li className="flex items-center space-x-3">
                <SafeIcon icon={FiMail} className="text-[#E30613]" />
                <a href="mailto:nadine.rau@smarte-buchhaltung.online" className="text-gray-300 hover:text-red-500 transition-colors">
                  nadine.rau@smarte-buchhaltung.online
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <SafeIcon icon={FiPhone} className="text-[#E30613]" />
                <a href="tel:+4956143027276" className="text-gray-300 hover:text-red-500 transition-colors">
                  0561 / 43027276
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <SafeIcon icon={FiMapPin} className="text-[#E30613] mt-1" />
                <span className="text-gray-300">
                  Bettenhäuserstr. 1<br />
                  34123 Kassel
                </span>
              </li>
            </ul>
          </motion.div>
        </div>
        <motion.div 
          initial={{ opacity: 0, y: 30 }} 
          whileInView={{ opacity: 1, y: 0 }} 
          transition={{ duration: 0.6, delay: 0.3 }} 
          viewport={{ once: true }}
          className="border-t border-gray-700 mt-12 pt-8 text-center"
        >
          <p className="text-gray-400">
            © 2024-2026 Nadine Rau u. Mike Trepte GbR. Alle Rechte vorbehalten.
          </p>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;